import { useShallow } from 'zustand/shallow';
import { useGcsStore } from '../../../store/useGcsStore';
import { useFleetVisibilityStore as useSelectsFleetVisibility } from '../../../store/useFleetVisibilityStore';
import { selectIsVehicleUnderMyControl } from '../../../store/selectors/selectIsVehicleUnderMyControl';
import { selectVehicleStatusCategory } from '../../../store/selectors/selectVehicleStatusCategory';
import { VehicleStatusCategory } from '../../../types/ui/vehicleStatusCategory';
import SegmentedControl from '../../../components/general/SegmentedControl';
import { en } from '../../../locales/en';

function getInflightCountLabelColor(count: number, maxVehiclesPerRpic: number | undefined): string | undefined {
  if (!maxVehiclesPerRpic) return undefined;
  if (count < maxVehiclesPerRpic) return undefined;
  if (count === maxVehiclesPerRpic) return 'var(--color-warning)';
  return 'var(--color-danger)';
}

function FleetVisibilitySegmentedControl() {
  const { visibility, setVisibility } = useSelectsFleetVisibility();

  const { allInflightCount, myInflightCount, maxVehiclesPerRpic } = useGcsStore(
    useShallow((state) => {
      let allCount = 0;
      let myCount = 0;
      let maxVehiclesPerRpic: number | undefined;
      state.data.forEach((gcsData, gcsId) => {
        const gcsMaxVehiclesPerRpic = gcsData.user.data?.maxVehiclesPerRpic;
        if (gcsMaxVehiclesPerRpic != null) {
          maxVehiclesPerRpic =
            maxVehiclesPerRpic === undefined
              ? gcsMaxVehiclesPerRpic
              : Math.min(maxVehiclesPerRpic, gcsMaxVehiclesPerRpic);
        }
        gcsData.vehicles.data?.forEach((vehicle) => {
          const category = selectVehicleStatusCategory(state.data, gcsId, vehicle.id);
          if (
            category === VehicleStatusCategory.INFLIGHT_NOMINAL ||
            category === VehicleStatusCategory.INFLIGHT_FAILURE_MODE
          ) {
            allCount++;
            if (selectIsVehicleUnderMyControl(state.data, gcsId, vehicle.id)) {
              myCount++;
            }
          }
        });
      });
      return {
        allInflightCount: allCount,
        myInflightCount: myCount,
        maxVehiclesPerRpic: maxVehiclesPerRpic
      };
    })
  );

  return (
    <SegmentedControl
      options={[
        {
          label: `${en.sidePanel.myVehicles} (${en.sidePanel.inflightCount.replace('{count}', String(myInflightCount))})`,
          value: 'mine',
          labelColor: getInflightCountLabelColor(myInflightCount, maxVehiclesPerRpic)
        },
        {
          label: `${en.sidePanel.allVehicles} (${en.sidePanel.inflightCount.replace('{count}', String(allInflightCount))})`,
          value: 'all'
        }
      ]}
      selectedValue={visibility}
      onValueChange={setVisibility}
    />
  );
}

export default FleetVisibilitySegmentedControl;
